function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "51.9,33.1 42.9,24 34.8,32 32.7,29.9 42.9,19.7 51.9,28.8 61,19.7 71.2,29.9 69.1,32 61,24  "
}))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M65.8,86.6H40.7v-1.5c0-12.9-13.2-25.3-13.3-25.4C20.9,53.2,17.2,44.2,17.2,35c0-9.3,3.6-18,10.2-24.6 C34,3.8,42.7,0.2,51.9,0.2c9.3,0,18,3.6,24.5,10.1c6.6,6.6,10.2,15.3,10.2,24.5c0,9.3-3.7,18.3-10.2,24.7 c-0.1,0.1-10.6,10.9-10.6,25.5V86.6z M43.7,83.6h19.1c0.7-15,11-25.6,11.5-26.1c5.9-5.9,9.3-14.1,9.3-22.6 c0-8.5-3.3-16.4-9.3-22.4c-6-6-13.9-9.3-22.4-9.3c-8.4,0-16.4,3.3-22.4,9.3c-6,6-9.3,14-9.3,22.5c0,8.4,3.4,16.6,9.3,22.5 C30.1,58,42.8,70,43.7,83.6z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 40.2,
  y: 97,
  width: 25.8,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 40.2,
  y: 90.5,
  width: 25.8,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "51.9,43.5 42.9,34.4 34.8,42.4 32.7,40.3 42.9,30.1 51.9,39.2 61,30.1 71.2,40.3 69.1,42.4 61,34.4  "
}))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 51.6,
  y: 50,
  width: 3,
  height: 25.8
})))));

var SvgLightBulb = function SvgLightBulb(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/light-bulb.004b15ce.svg";
export { SvgLightBulb as ReactComponent };